<template>
  <b-card>
    <table-component
      :section="'project'"
      :detail-url="'projectDetail'"
      :columns="columns"
    />
  </b-card>
</template>

<script>
import TableComponent from '@/layouts/components/TableComponent.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    TableComponent,
    BCard,
  },
  data() {
    return {
      columns: [
        {
          label: '#',
          field: 'id',
          type: 'number',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '50px',
        },
        {
          label: 'ProjectId',
          field: 'id',
          tdClass: 'text-center',
          thClass: 'text-center',
          width: '150px',
        },
        {
          label: 'Project Code',
          field: 'projectCode',
        },
        {
          label: 'Project Name',
          field: 'projectName',
        },
        {
          label: 'Status',
          field: 'status',
        },
      ],
    }
  },
}
</script>
